import { buildCallIntervalValueProvider } from './CallIntervalValueProvider';
import { buildMessageTypeValueProvider } from './MessageTypeValueProvider';
import { buildRepeatCallValueProvider } from './RepeatCallValueProvider';
import { buildOwnersValueProvider } from './buildOwnersValueProvider';
export function buildAlertsValueProviders(appName) {
    return [
        // from AlertService backend
        buildOwnersValueProvider(),
        // from platform app
        buildMessageTypeValueProvider(appName),
        buildRepeatCallValueProvider(appName),
        buildCallIntervalValueProvider(appName),
    ];
}
